import { Controller } from "@hotwired/stimulus"

// Keeps the dependent codebook selects of "Všeobecné podanie" in step.
//
// Every option is rendered by the server and carries the parent value(s) it
// belongs to in `data-parents`; this controller only decides which of them the
// current selection leaves visible. The server validates the result again.
export default class extends Controller {
  static targets = [
    "administrationBody",
    "taxOfficeWrapper",
    "submissionArea",
    "agenda",
    "serviceType",
    "submissionType",
    "feeSection",
    "feeSchedule",
    "serviceName",
    "outputFormat",
    "exemption",
    "exemptionReasonWrapper"
  ]

  connect() {
    this.refresh()
  }

  refresh() {
    this.toggleTaxOffice()
    this.filterByParent(this.optional("agenda"), this.targetValue("submissionArea"))
    this.filterByParent(this.optional("submissionType"), this.targetValue("serviceType"))
    this.toggleFeeSection()
    this.filterByParent(this.optional("feeSchedule"), this.targetValue("submissionType"))
    this.filterByParent(this.optional("serviceName"), this.targetValue("feeSchedule"))
    this.restrictOutputFormat()
    this.toggleExemptionReason()
  }

  // Stimulus target getters throw when the target is absent, and this form
  // renders a few of them conditionally.
  optional(name) {
    const capitalized = name.charAt(0).toUpperCase() + name.slice(1)
    return this[`has${capitalized}Target`] ? this[`${name}Target`] : null
  }

  targetValue(name) {
    const target = this.optional(name)
    return target ? target.value : ""
  }

  // The Financial Directorate is not addressed through a tax office.
  toggleTaxOffice() {
    if (!this.hasAdministrationBodyTarget || !this.hasTaxOfficeWrapperTarget) return

    this.taxOfficeWrapperTarget.classList.toggle("d-none", this.administrationBodyTarget.value !== "DU")
  }

  toggleFeeSection() {
    if (!this.hasFeeSectionTarget || !this.hasServiceTypeTarget) return

    this.feeSectionTarget.classList.toggle("d-none", this.serviceTypeTarget.value !== "1")
  }

  toggleExemptionReason() {
    if (!this.hasExemptionTarget || !this.hasExemptionReasonWrapperTarget) return

    this.exemptionReasonWrapperTarget.classList.toggle("d-none", !this.exemptionTarget.checked)
  }

  // Only services deliverable in a given form may be picked for it.
  restrictOutputFormat() {
    if (!this.hasOutputFormatTarget || !this.hasServiceNameTarget) return

    const selected = this.serviceNameTarget.options[this.serviceNameTarget.selectedIndex]
    const output = selected ? selected.dataset.output || "both" : "both"

    Array.from(this.outputFormatTarget.options).forEach((option) => {
      if (option.value === "") return

      const allowed =
        output === "both" ||
        (output === "electronic" && option.value === "E") ||
        (output === "paper" && option.value === "P")

      option.hidden = !allowed
      option.disabled = !allowed
    })

    const current = this.outputFormatTarget.selectedOptions[0]
    if (current?.disabled) this.outputFormatTarget.value = ""
    if (output === "electronic") this.outputFormatTarget.value = "E"
    if (output === "paper") this.outputFormatTarget.value = "P"
  }

  filterByParent(select, parentValue) {
    if (!select) return

    let selectionSurvives = false

    Array.from(select.options).forEach((option) => {
      if (option.value === "") return

      const parents = (option.dataset.parents || "").split(" ").filter(Boolean)
      const visible = parents.length === 0 || parents.includes(parentValue)

      option.hidden = !visible
      option.disabled = !visible
      if (visible && option.value === select.value) selectionSurvives = true
    })

    if (!selectionSurvives) select.value = ""
  }
}
